import { useCompanyInfo } from 'core/hooks'

const useCompanyCommunicationInfo = () => {
  const { communication } = useCompanyInfo()
  return communication || {}
}

export default useCompanyCommunicationInfo
